import React from "react";
import { TERMS_VERSION, TERMS_HASH, TERMS_LAST_MODIFIED, TERMS_SECTIONS } from "../../utils/termsContent";

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Use</h1>
        <p className="text-sm text-gray-500 mb-8">
          Last Modified: {TERMS_LAST_MODIFIED} | Version {TERMS_VERSION}
        </p>

        {TERMS_SECTIONS.map((section, idx) => (
          <div key={idx} className="mb-8">
            {section.title && (
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{section.title}</h2>
            )}
            <div className="whitespace-pre-line text-sm text-gray-700 leading-[1.8]">
              {section.content}
            </div>
          </div>
        ))}

        <div className="mt-12 pt-6 border-t border-gray-200 text-xs text-gray-400">
          <p>Version: {TERMS_VERSION}</p>
          <p>Terms Hash: {TERMS_HASH}</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
